export default "__VITE_PUBLIC_ASSET__ad482211__"